import { render, staticRenderFns } from "./CurrentBalance.vue?vue&type=template&id=5a734b12"
import script from "./CurrentBalance.vue?vue&type=script&lang=js"
export * from "./CurrentBalance.vue?vue&type=script&lang=js"
import style0 from "./CurrentBalance.vue?vue&type=style&index=0&id=5a734b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports